import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Label,
    Button,
    Input,
    Table,
    Spinner,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
//import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import moment from "moment"
import { isEmpty } from "lodash"
import ButtonSpinner from "components/ButtonSpinner"
import * as clientAction from "../../../store/bW9udGhXaXNlQ2/actions"
import MonthWiseTableComponent from "./MonthWiseTableComponent"
import api from "helpers/Api"
import ReactDOM from 'react-dom'
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"


const MonthWiseClientClosureReport = (props) => {
    const { searchBtnStyle, dispatch } = props

    const title = "Month Wise Client Closure"

    //Fetching API
    useEffect(() => {
        dispatch(clientAction.loadMonthWiseClientClosure())
        // dispatch(clientAction.loadRecordsMetaData())
    }, [])

    const update = useSelector(
        (specificstate) => specificstate.monthWiseClientClosureReport
    )
    //Date format
    const sessionUpdate = useSelector((specificstate) => specificstate.session)
    const { user = [] } = sessionUpdate

    const dateSetting =
        !isEmpty(user) && user.setting && user.setting.dateFormate
            ? user.setting.dateFormate.toUpperCase()
            : []
    const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
    //product_data
    const {product_data = [] } = update
   
    //Handle Change
    const [productStatusData, setProductStatusData] = useState({
        eventFromDate: "",
        eventToDate: "",
    })

    const handleChange = (e) => {
        setProductStatusData({
            ...productStatusData,
            [e.target.name]: e.target.value,
        })
    }




    const [downloadLoading, setDownloadLoading] = useState(false)
    //Search value

    const [searchFilter, setSearchFilter] = useState(false)
    const [searchInput, setSearchInput] = useState("")
    const [btnLoader, setBtnLoader] = useState(false)



    const handleFilter = (e) => {
        e.preventDefault()

        // var searchEmployee = !isEmpty(products) && products ? products : ""
        var searchFromDate =
            productStatusData && productStatusData.eventFromDate
                ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
                : ""
        var searchToDate =
            productStatusData && productStatusData.eventToDate
                ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
                : ""

        var searchvalue = {}


        if (searchFromDate) {
            searchvalue.eventFromDate = searchFromDate
        }
        if (searchToDate) {
            searchvalue.eventToDate = searchToDate
        }

        dispatch(clientAction.loadMonthWiseClientClosure(searchvalue))
        setBtnLoader(true)
        setTimeout(() => {
            setBtnLoader(false)
        }, 3000)
    }

    //reset

    const resetForm = () => {

        setSearchInput("")
        setProductStatusData({
            ...productStatusData,
            eventFromDate: "",
            eventToDate: "",
        })
        //  dispatch(clientAction.loadMonthWiseClientClosure())
    }
    // data table


    const handleClick = (e) => {
        e.preventDefault()
        setSearchFilter(true)
        // dispatch(
        //     clientAction.loadMonthWiseClientClosure({
        //         searchFilter: searchInput,
        //     })
        // )
        setTimeout(() => {
            setSearchFilter(false)
        }, 1200)
    }
    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })

        const a = document.createElement("a")
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }



    //month values name and year functionality

    const monthsValue = !isEmpty(product_data) && !isEmpty(product_data[0].leadsCompleted) ? product_data[0].leadsCompleted : []
    const convertKey = (key) => {
        const [year, month] = key.split('_')
        const monthsList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        const monthName = monthsList[parseInt(month, 10) - 1]
        return `${monthName}-${year}`
    }

    const exportToCsv = () => {
        var searchFromDate =
            productStatusData && productStatusData.eventFromDate
                ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
                : ""
        var searchToDate =
            productStatusData && productStatusData.eventToDate
                ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
                : ""

        var searchvalue = {}


        if (searchFromDate) {
            searchvalue.eventFromDate = searchFromDate
        }
        if (searchToDate) {
            searchvalue.eventToDate = searchToDate
        }

        setDownloadLoading(true)

        api
            .post(`/get-completed-crm-report-monthlywise`, searchvalue)
            .then((response) => {
                const productDetails = response.data.data

                const monthsValue = !isEmpty(productDetails) && !isEmpty(productDetails[0].leadsCompleted) ? productDetails[0].leadsCompleted : []
                const formattedLeadsCompleted = !isEmpty(monthsValue) ? Object.keys(monthsValue[0]).map((key) => convertKey(key)) : ""


                const photoExportDataTable = !isEmpty(response.data.data)
                    ? response.data.data.map((data, index) => {
                        const crmName = data.empCode ? `${data.empCode} - ${data.name}` : ""
                        const monthCountValues = Object.values(data.leadsCompleted[0]).map((monthVal) => monthVal)
                        const rowTotal = Object.values(data.leadsCompleted[0]).reduce((acc, val) => acc + val, 0)
                        return {
                            _id: index,
                            sNo: index + 1,
                            crmName: crmName,
                            monthCountValues: monthCountValues,
                            rowTotal: rowTotal
                        }
                    })
                    : []
                setTimeout(() => {
                    // const headerKeys = Object.keys(formattedLeadsCompleted)
                    const headers = [
                        "S.No",
                        "CRM Name",
                        ...formattedLeadsCompleted, // Wrap headers in parentheses as requested
                        "Total",
                    ]
                    const headerData = [headers.join(",")]

                    let usersCsv =
                        !isEmpty(photoExportDataTable) &&
                        photoExportDataTable.reduce((acc, user) => {
                            const {
                                sNo,
                                crmName,
                                monthCountValues,
                                rowTotal
                            } = user
                            acc.push([
                                sNo,
                                crmName,
                                monthCountValues,
                                rowTotal
                            ])

                            return acc
                        }, [])
                    // const columnTotals = !isEmpty(monthsValue) && Object.keys(monthsValue[0]).map((key) => {
                    //     const total =  productDetails.reduce((acc, data) => acc + (data.leadsCompleted[0][key] || 0), 0)
                    //     return total
                    // })
                    // const columnTotals = monthsValue.length ? monthsValue.reduce((acc, month) => {
                    //     Object.keys(month).forEach(key => {
                    //         if (key !== "sNo" && key !== "crmName") {
                    //             acc[key] = (acc[key] || 0) + month[key]
                    //         }
                    //     })
                    //     return acc
                    // }, {}) : {}
                    const columnTotals = photoExportDataTable.length > 0 ? photoExportDataTable.reduce((totals, user) => {
                        user.monthCountValues.forEach((value, index) => {
                            totals[index] = (totals[index] || 0) + value
                        })
                        return totals
                    }, []) : []

                    // Add row for column-wise totals
                    const totalRow = ['', 'Total Unique Client Completed', ...columnTotals, photoExportDataTable.reduce((acc, user) => acc + user.rowTotal, 0), '']
                    usersCsv.push(totalRow)
                    const csvData = usersCsv.map(row => row.join(",")).join("\n")
                    downloadFile({
                        data: `${headerData.join("\n")}\n${csvData}`,
                        fileName: "MonthWiseClientClosure.csv",
                        fileType: "text/csv",
                    })
                    setDownloadLoading(false)
                }, 500)
                return response.data
            })
            .catch((error) => Promise.reject(error))
        // }
    }

    const handleClickTab = (tableData) => {

        const statusName = tableData.status

        let statusDetails = {
            "year_month": tableData.year_month,
            "crmId": tableData.crmId

        }
        api
            .post(`/get-one-completed-crm-report`, statusDetails)
            .then((response) => {
              
                const data =  !isEmpty(response.data.data) ? response.data.data : []
                const  statusData = !isEmpty(data)?data.flatMap(m=>m.leadsCompleted):[]
                setTimeout(() => {
                    // Use the current value of statusData, which should be updated due to the useEffect
                 
                    const newTab = window.open("", "_blank", "width=600,height=400")
                    if (newTab) {
                        const container = newTab.document.createElement("div")
                        newTab.document.body.appendChild(container)
                        ReactDOM.render(
                            <MonthWiseTableComponent
                                data={statusData} // Use statusData directly here
                                dispatch={dispatch}
                                statusPayload={statusDetails}
                                name={statusName}
                                dateFormat={dateFormat}

                            />,
                            container
                        )
                        newTab.document.title = "MONTH-WISE-CLIENT-DELIVERABLE"
                    }
                }, 1000)
            })
            .catch((error) => {
                Promise.reject(error)

            })
    }
  
    return (
        <div className="page-content">
            <MetaTags>
                <title>{title} | Zero Gravity CRM</title>
            </MetaTags>
            <Container fluid>
                <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
                <Row>
                    <Col xs={12}>
                        <Card>
                            <CardBody>
                                <form>
                                    <Row>

                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label className={"form-label"} htmlFor={"Event Date"}>
                                                    {"Event From Date"}
                                                </Label>
                                            </div>
                                            <Input
                                                type="date"
                                                name="eventFromDate"
                                                value={productStatusData.eventFromDate}
                                                max={productStatusData.eventToDate}
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Enter "
                                            />
                                        </Col>

                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label
                                                    className={"form-label"}
                                                    htmlFor={"Event To Date"}
                                                >
                                                    {"Event To Date"}
                                                </Label>
                                            </div>
                                            <Input
                                                type="date"
                                                name="eventToDate"
                                                value={productStatusData.eventToDate}
                                                min={productStatusData.eventFromDate}
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Enter "
                                            />
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                                            <div
                                                className="filter-buttons"
                                                style={{ float: "right" }}
                                            >
                                                <Button
                                                    type="button"
                                                    className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                                                    onClick={() => {
                                                        resetForm()
                                                    }}
                                                >
                                                    <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                                                    Reset
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    onClick={(e) => handleFilter(e)}
                                                    className="btn btn-success btn-label simple-form-applyfilter-btn"
                                                >
                                                    <i className="bx bx-filter-alt label-icon"></i>
                                                    {btnLoader && btnLoader ? (
                                                        <ButtonSpinner />
                                                    ) : (
                                                        "Apply Filter"
                                                    )}{" "}
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md="12" lg="12" xl="12">
                        <Card>
                            <CardBody>
                                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                        <form onSubmit={handleClick} className="d-flex flex-row">
                                            <div style={searchBtnStyle || null}>
                                                <Input
                                                    type="text"
                                                    name="searchInput"
                                                    value={searchInput}
                                                    onChange={(e) => setSearchInput(e.target.value)}
                                                    className="form-control"
                                                    placeholder="Search"
                                                    style={{ position: "relative" }}
                                                />
                                                <i
                                                    className="bx bx-search-alt"
                                                    style={{
                                                        position: "absolute",
                                                        top: "54px",
                                                        left: "41px",
                                                        fontSize: "13px",
                                                    }}
                                                />
                                            </div>

                                            <button
                                                className="btn btn-success mx-2"
                                                type="submit"
                                                style={{
                                                    background: searchFilter ? "#2ca67a" : "",
                                                    color: searchFilter ? "#ffffff" : "",
                                                }}
                                            >
                                                <i className="fas fa-search"></i>
                                            </button>
                                        </form>
                                    </div>
                                </div>
                                <Row>
                                    <Col md="4" lg="4" sm="12"></Col>
                                    <Col
                                        md="8"
                                        lg="8"
                                        sm="12"
                                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                                    >
                                        <div
                                            style={{
                                                float: "right",
                                            }}
                                        >
                                            <Button
                                                className="btn btn-primary"
                                                onClick={exportToCsv}
                                                id="download"
                                                style={{
                                                    backgroundColor: "#e40d8c",
                                                    color: "white",
                                                    border: "none",
                                                }}
                                            >
                                                Download
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>

                                <Col md="12" lg="12" xl="12" className="mt-3">

                                    <Table responsive bordered>
                                        <thead>
                                            <tr>
                                                <th style={{
                                                    minWidth: "230px",
                                                    textAlign: "center"
                                                }}>CRM Name</th>
                                                {!isEmpty(monthsValue) ? Object.keys(monthsValue[0]).map((key, index) => (
                                                    <th key={index} style={{ minWidth: "120px", textAlign: "center" }}>
                                                        {convertKey(key)}
                                                    </th>
                                                )) : ""}
                                                <th style={{
                                                    minWidth: "120px",
                                                    textAlign: "center"
                                                }}>Total</th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            {!isEmpty(product_data) ? product_data.map((data, index) => {
                                                const crmName = data.empCode ? `${data.empCode} - ${data.name}` : ""
                                                const rowTotal = Object.values(data.leadsCompleted[0]).reduce((acc, val) => acc + val, 0)
                                                 const  crmId = data._id
                                  
                                                return (
                                                    <tr key={index}>
                                                        <th>{crmName}</th>
                                                        {Object.entries(data.leadsCompleted[0]).map(([key,monthVal], idx) => {
                                                            const payload = {
                                                                "year_month":key,
                                                                "crmId": crmId,
                                                                "status":data.name
                                                            }


                                                            return (<td style={{
                                                                fontWeight: 'bold',
                                                                color: "#e40d8c",
                                                                fontSize: "14px",
                                                                textDecoration: "underline",
                                                                minWidth: "120px",
                                                                textAlign: "center"
                                                            }}
                                                                key={idx}
                                                                onClick={() => handleClickTab(payload)}>{monthVal}</td>)
                                                        })}
                                                        <th style={{
                                                            minWidth: "120px",
                                                            textAlign: "center"
                                                        }}>{rowTotal}</th>
                                                    </tr>
                                                )
                                            }) : []}
                                            <tr>
                                                <th>Total Unique Client Completed</th>
                                                {!isEmpty(monthsValue) && Object.keys(monthsValue[0]).map((key, idx) => {
                                                    const total = product_data.reduce((acc, data) => acc + (data.leadsCompleted[0][key] || 0), 0)
                                                    return <th style={{
                                                        minWidth: "120px",
                                                        textAlign: "center"
                                                    }} key={idx}>{total}</th>
                                                })}
                                                <th style={{
                                                    minWidth: "120px",
                                                    textAlign: "center"
                                                }}>
                                                    {!isEmpty(product_data) && product_data.reduce((acc, data) => acc + Object.values(data.leadsCompleted[0]).reduce((total, val) => total + val, 0), 0)}
                                                </th>
                                            </tr>
                                        </tbody>
                                    </Table>
                                    <div className="font-size-14 mt-2">
                                        <p>Showing Rows 0 to 0 of 0</p>
                                    </div>
                                </Col>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            {downloadLoading ? (
                <Modal
                    show={downloadLoading}
                    style={{ width: "7%", margin: "18% 50%" }}
                >
                    <Modal.Body>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="lg"
                            role="status"
                            aria-hidden="true"
                            variant="success"
                            className="mx-2"
                            color="success"
                        />
                    </Modal.Body>
                </Modal>
            ) : (
                ""
            )}
        </div>
    )
}
MonthWiseClientClosureReport.propTypes = {
    dispatch: PropTypes.func,
    searchBtnStyle: PropTypes.any,
    dateFormat: PropTypes.string
}
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}
const mapStateToProps = () => ({
    // employee: state.employeeRequest.employee,MonthWiseClientClosureReport
})

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MonthWiseClientClosureReport)
)
